import { CommonHorizontalArrow2Icon } from '@local/assets/icons'

import Clickable from '@web/ui/components/Clickable'

import styles from './UIAcceptFollowNudge.module.scss'

interface Props {
  displayNickname: string
  onManageClick?: () => void
  manageClickCode?: string
}

const UICompleteFollowNudge = ({ displayNickname, onManageClick, manageClickCode }: Props) => {
  return (
    <div className={styles.following_request_area}>
      <span className={styles.txt}>
        <strong>{displayNickname}</strong>님의 팔로우 신청을 수락하였습니다.
      </span>
      <Clickable className={styles.btn_manage} onClick={onManageClick} nClickCode={manageClickCode}>
        관리
        <CommonHorizontalArrow2Icon className={styles.icon} aria-hidden="true" />
      </Clickable>
    </div>
  )
}

export default UICompleteFollowNudge
